import { render, staticRenderFns } from "./JbManPreventivaOpcoes.vue?vue&type=template&id=21e345ca&"
import script from "./JbManPreventivaOpcoes.vue?vue&type=script&lang=js&"
export * from "./JbManPreventivaOpcoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports